import { DOCUMENT } from '@angular/common';
import { Component, EventEmitter, Inject, Input, OnChanges, OnInit, Output, SimpleChanges, ViewContainerRef } from '@angular/core';
import { MatMenu } from '@angular/material/menu';
import { Router } from '@angular/router';
import { convertEpochToDateString, GlobalFunctions } from '@global/GlobalFunctions';
import { EventsDataService } from '@services/events-data.service';
import { IntegrationsService, IWebhookIntegration } from '@services/integrations.service';
import { siteSubscriptions } from '@services/siteSubscriptions';
import { Subject, takeUntil, distinctUntilChanged, filter, finalize } from 'rxjs';

@Component({
	selector: 'app-dashboard-webhooks',
	templateUrl: './dashboard-webhooks.component.html',
	styleUrl: './dashboard-webhooks.component.scss'
})
export class DashboardWebhooksComponent implements OnChanges, OnInit {

	/** accountGUID */
	@Input() accountGUID: string;

	/** organisationUID */
	@Input() organisationUID: string;

	/** panelData */
	@Input() panelData: any;

	/** startTime */
	@Input() startTime: number;

	/** endTime */
	@Input() endTime: number;

	/** creating */
	@Input() creating: boolean;

	/** titleMenu */
	@Input() titleMenu: MatMenu;

	/** refresh */
	@Input() refresh: boolean;

	/** inputWebhooks */
	public inputWebhooks: IWebhookIntegration[] = [];

	/** webhooks */
	public webhooks: IWebhookIntegration[] = [];

	/** offlineWebhooks */
	public offlineWebhooks: IWebhookIntegration[] = [];

	/** onlineWebhooks */
	public onlineWebhooks: IWebhookIntegration[] = [];

	/** filteredWebhooks */
	public filteredWebhooks: IWebhookIntegration[] = [];

	/** whFields */
	public whFields: Object = { text: "Description", value: "WebhookID" };

	/** showDisabled */
	public showDisabled: boolean = false;

	/** beginWebhookInterval */
	@Output() beginWebhookInterval = new EventEmitter<boolean>();

	/**
	 * Default Constructor
	 * @param globalFunctions globalFunctions  
	 * @param eventsDataService eventsDataService 
	 * @param siteSubscriptions siteSubscriptions 
	 * @param document document 
	 * @param vcr vcr 
	 */
	constructor(
		public globalFunctions: GlobalFunctions,
		public eventsDataService: EventsDataService,
		public router: Router,
		private siteSubscriptions: siteSubscriptions,
		@Inject(DOCUMENT) public document: Document,
		private integrationsService: IntegrationsService,
		private vcr: ViewContainerRef
	) {
	}

	/**
	 * ngOnInit
	 */
	ngOnInit(): void {
		this.getWebhooks();
		this.beginWebhookInterval.emit(true);
	}

	/**
	 * ngOnChanges
	 * @param changes changes 
	 */
	ngOnChanges(changes: SimpleChanges): void {
		if (changes["panelData"] && this.panelData) {
			if (this.panelData.webhooks) {
				this.inputWebhooks = this.panelData.webhooks;
				// this.getWebhooks();
			}
		}
		if (changes["refresh"] && this.refresh == true) {
			this.getWebhooks();
			// console.log("refresh webhooks");
		}
	}

	/** getWebhooks */
	getWebhooks() {
		// Create a local Subject to control the subscription lifecycle
		const fetchDataSubject = new Subject<void>();

		this.integrationsService.getWebhookIntegrations$(this.accountGUID, this.organisationUID).pipe(
			takeUntil(fetchDataSubject), distinctUntilChanged(),
			filter((assets) => !!assets),
			finalize(() => {
				// Ensure the subscription is terminated and the subject is completed
				fetchDataSubject.next();
				fetchDataSubject.complete();
				this.filterWebhooks();
				this.globalFunctions.displaySpinner(false);
			})
		).subscribe({
			next: (webhooks: any) => {
				if (this.inputWebhooks.length == 0) {
					this.webhooks = webhooks;
				} else {
					this.webhooks = webhooks.filter((x: IWebhookIntegration) => this.inputWebhooks.map((y: IWebhookIntegration) => y.WebhookID).includes(x.WebhookID));
				}
			},
			error: (error) => {
				if (error.status === 404) {
					this.webhooks = [];
				}
			}
		});
	}

	/**
	 * convertEpoch
	 * @param epoch
	 * @returns
	 */
	convertEpoch(epoch: number): string {
		/** Use the Global Function */
		return convertEpochToDateString(epoch);
	}

	/**
	 * filterWebhooks
	 */
	filterWebhooks() {
		this.filteredWebhooks = this.webhooks.filter((x: IWebhookIntegration) => x.Enabled == this.showDisabled ? x.Enabled : true);
		this.offlineWebhooks = this.filteredWebhooks.filter((x: IWebhookIntegration) => x.Offline);
		this.onlineWebhooks = this.filteredWebhooks.filter((x: IWebhookIntegration) => !x.Offline);
		this.onlineWebhooks.sort((a: IWebhookIntegration, b: IWebhookIntegration) => b.LastValueReceived - a.LastValueReceived);
		this.filteredWebhooks = [...this.offlineWebhooks, ...this.onlineWebhooks];
	}

	/**
	 * toggleShowDisabled
	 * @param event event 
	 */
	toggleShowDisabled(event: any) {
		this.showDisabled = event.checked;
		this.filterWebhooks();
	}
}
